import React, { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Provider as MainProvider } from './FormContext';
import AlertError from '../State/AlertError';
import TranslationsContext from '../../Container/Language/TranslationsContext';

const FormProvider = ({
  children,
  sendRequest,
  formName,
  Provider: PersonalProvider,
  ...other
}) => {
  const { t } = useContext(TranslationsContext);
  const [form, setForm] = useState({
    formLoading: false,
    formErrors: null,
    formData: null,
  });
  // Sync guard: disabled={formLoading} is too late for double-clicks
  // (state updates only after re-render), so a second POST can fire first.
  const submittingRef = useRef(false);

  const clearData = () => {
    submittingRef.current = false;
    setForm({
      formLoading: false,
      formErrors: null,
      formData: null,
    });
  };

  const sendForm = (data, opts, callback) => {
    if (submittingRef.current) {
      return;
    }
    submittingRef.current = true;

    setForm({
      formLoading: true,
      formErrors: null,
      formData: null,
    });

    sendRequest(formName, { ...opts || {}, body: data }).then((response) => {
      submittingRef.current = false;

      const formResponse = {
        formLoading: false,
        formErrors: null,
        formData: null,
      };

      if (response.success) {
        // const message = t(`toast.${formName}`);
        // if (message && message.substring(0, 6) !== 'toast.') addToast(message);

        formResponse.formData = response || { success: true };
      } else if (response.errors) {
        formResponse.formErrors = response.errors;
        formResponse.formData = response.data || null;
      } else {
        formResponse.formData = response;
      }
      setForm(formResponse);

      if (typeof callback === 'function') {
        callback(response);
      }
    });
  };

  const { formLoading, formErrors, formData } = form;
  const Provider = PersonalProvider || MainProvider;

  return (
    <Provider
      value={{
        ...other,
        formLoading,
        formErrors,
        formData,
        sendForm,
        sendRequest,
        clearData,
      }}
    >
      <AlertError error={formErrors && formErrors.access ? t('app:notify:operation:forbidden') : null} />

      {children}
    </Provider>
  );
};

FormProvider.propTypes = {
  children: PropTypes.node,
  formName: PropTypes.string.isRequired,
  sendRequest: PropTypes.func.isRequired,
  Provider: PropTypes.instanceOf(Object),
};

FormProvider.defaultProps = {
  children: null,
  Provider: null,
};

export default FormProvider;
